var $4ab930b6f557bd85$exports = {};
$4ab930b6f557bd85$exports = {
    "info": `\u{8CC7}\u{8A0A}`,
    "negative": `\u{932F}\u{8AA4}`,
    "positive": `\u{6210}\u{529F}`
};


export {$4ab930b6f557bd85$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
